/**
 * Collect leaf location ids from grouped/single location rows used by
 * Origins/Destinations dropdowns (Home + Shipments).
 */
export function extractGroupedLocationLeafIds(
  items: Array<{
    type?: string;
    id?: string | number;
    locations?: Array<{ id?: string | number }>;
  }>
): string[] {
  const ids: string[] = [];
  for (const item of items) {
    if (item?.type === 'group' && Array.isArray(item.locations)) {
      for (const child of item.locations) {
        if (child?.id != null) ids.push(String(child.id));
      }
    } else if (item?.id != null) {
      ids.push(String(item.id));
    }
  }
  return ids;
}

export function extractGroupedLocationLeafOptions(
  items: Array<{
    type?: string;
    id?: string | number;
    name?: string;
    display_name?: string;
    locations?: Array<{ id?: string | number; name?: string }>;
  }>
): Array<{ id: string; name: string }> {
  const out: Array<{ id: string; name: string }> = [];
  for (const item of items) {
    if (item?.type === 'group' && Array.isArray(item.locations)) {
      for (const child of item.locations) {
        if (child?.id != null) {
          out.push({
            id: String(child.id),
            name: child.name || String(child.id),
          });
        }
      }
    } else if (item?.id != null) {
      out.push({
        id: String(item.id),
        name: item.name || item.display_name || String(item.id),
      });
    }
  }
  return out;
}
